// Utils
import { getStartOfDayDate, TIMES, toEpochMs } from '../utils/timeUtil';

// Constants
import { REMINDER_VALUES } from './reminderConstants';

const getTimestampAt9amOn =
    (daysBefore: number) =>
    (date: Date): number => {
        const updatedDate = getStartOfDayDate(date);
        updatedDate.setHours(9);
        updatedDate.setDate(updatedDate.getDate() - daysBefore);
        return updatedDate.getTime();
    };

const getTimestampAt9amOnDay = getTimestampAt9amOn(0);
const getTimestampAt9amOnDayBefore = getTimestampAt9amOn(1);

export const getTimestampForReminder = ({
    dueDate,
    dueReminder,
}: {
    /**
     * A due date as it is persisted, which is not one shape: the task due date picker writes an
     * ISO string, while the task item attr and older writes hold epoch milliseconds.
     */
    dueDate: Date | number | string | null | undefined;
    dueReminder: string | null | undefined;
}): number | null => {
    const dueDateTimestamp = toEpochMs(dueDate);

    if (dueDateTimestamp === undefined) return null;

    const date = new Date(dueDateTimestamp);

    switch (dueReminder) {
        case REMINDER_VALUES.WHEN_DUE:
            return dueDateTimestamp;
        case REMINDER_VALUES.TEN_MINUTES_BEFORE:
            return dueDateTimestamp - 10 * TIMES.MINUTE;
        case REMINDER_VALUES.ONE_HOUR_BEFORE:
            return dueDateTimestamp - TIMES.HOUR;
        case REMINDER_VALUES.NINE_AM_DAY_OF:
            return getTimestampAt9amOnDay(date);
        case REMINDER_VALUES.NINE_AM_DAY_BEFORE:
            return getTimestampAt9amOnDayBefore(date);
        case REMINDER_VALUES.NONE:
        default:
            return null;
    }
};
